// @flow
import React from "react";
import ReactDOM from "react-dom";
import classNames from "classnames";
import Spinner from "react-spin";
import $ from "jquery";
import type { PublishMessageData } from "./types/publish.js";

const PRODUCTION = 1;
const CONTENT_STAGING = 2;

function PublishHeading(props: { target: ?number }) {
  var target = props.target;
  if (target == null) {
    return null;
  }
  if (target == PRODUCTION) {
    return (
      <div className="publish-heading production">
        <h2>Publishing to Production App</h2>
      </div>
    );
  }
  if (target == CONTENT_STAGING) {
    return (
      <div className="publish-heading preview">
        <h2>Publishing to Preview App</h2>
      </div>
    );
  }
}

class PublishMessage extends React.PureComponent {
  props: {
    message: PublishMessageData
  };
  getClassName(): classNames {
    var logLevel = this.props.message.log_level;
    return classNames({
      alert: true,
      warning: logLevel == "WARNING",
      success: logLevel == "SUCCESS",
      error: logLevel == "ERROR" || logLevel == "PUBLISH_ABORTED"
    });
  }

  getText(): string {
    var logLevel = this.props.message.log_level;
    var message = this.props.message.message;

    var text = message;
    switch (logLevel) {
      case "BEGIN":
        text = "generating JSON";
        break;
      case "ERROR":
      case "PUBLISH_ABORTED":
        text = `ERROR: ${message}`;
        break;
    }

    return text;
  }

  getSeconds(): string {
    var seconds = this.props.message.time_taken_seconds;
    var text = "";

    if (seconds == null) {
      return "";
    }

    if (seconds < 2.0) {
      text = "less than 2 seconds";
    } else if (seconds < 60.0) {
      text = `${seconds} seconds`;
    } else {
      var minutes = Math.floor(seconds / 60.0);
      var remainderSeconds = seconds - minutes * 60;
      text = `${minutes} minutes ${remainderSeconds} seconds`;
    }

    return ` (${text})`;
  }

  render() {
    return (
      <div className={this.getClassName()}>
        {this.getText()}{this.getSeconds()}
      </div>
    );
  }
}

class PublishContainer extends React.Component {
  state: {
    messages: PublishMessageData[],
    publishInProgress: boolean,
    publishTarget: ?number,
    jobId: ?number
  };
  props: {};

  constructor(props: {}) {
    super(props);
    this.state = {
      messages: [],
      publishInProgress: false,
      publishTarget: null,
      jobId: null
    };
  }

  onFetchMessagesTick() {
    if (this.state.jobId == null || this.state.publishInProgress == false) {
      return;
    }
    $.ajax({
      type: "GET",
      url: "/app-server-api/ajax/get-publish-status/",
      data: { job_id: this.state.jobId }
    }).done(
      (response: { messages: PublishMessageData[], finished: boolean }) => {
        if (response.messages.length == 0) {
          return;
        }
        this.setState({
          messages: response.messages,
          publishInProgress: !response.finished
        });
      }
    );
  }

  onPublishClick(evt: Event) {
    evt.preventDefault();
    var button = $(evt.target);
    var publishTarget = button.hasClass("production")
      ? PRODUCTION
      : CONTENT_STAGING;

    $.get(
      "/app-server-api/ajax/get-publish-job-id/",
      (data: { publish_job_id: number }) => {
        let jobId = data.publish_job_id;
        this.setState({
          jobId: jobId,
          messages: [
            {
              message: `Starting publish routine (id ${jobId})`
            }
          ]
        });
        $.ajax({
          type: "POST",
          url: "/app-server-api/ajax/publish/",
          data: {
            job_id: jobId,
            target: publishTarget
          }
        })
          .always(response => {
            //nothing to do here. The final update of UI status messages is handled by
            // the get_latest_messages interval.
          })
          .done(response => {
            //nothing to do here. The final update of UI status messages is handled by
            // the get_latest_messages interval.
          })
          .fail(response => {
            this.setState({
              publishInProgress: false,
              messages: [
                {
                  log_level: "ERROR",
                  message: response.responseText
                }
              ]
            });
          });
      }
    );

    $("[js-publish-button]").addClass("disabled");
    this.setState({
      publishTarget: publishTarget,
      publishInProgress: true
    });
  }

  componentDidMount() {
    $("[js-publish-button]").on("click", this.onPublishClick.bind(this));
    window.setInterval(this.onFetchMessagesTick.bind(this), 2000);
  }

  render() {
    var spinner = null;
    if (this.state.publishInProgress) {
      spinner = (
        <div className="spinner-container">
          <Spinner config={{ color: "#00a8bd" }} />
        </div>
      );
    }
    return (
      <div>
        <PublishHeading target={this.state.publishTarget} />
        <div id="results">
          {this.state.messages.map((message, index) =>
            <PublishMessage message={message} key={index} />
          )}
        </div>
        {spinner}
      </div>
    );
  }
}

if (document.getElementById("react-publish-container")) {
  ReactDOM.render(
    <PublishContainer />,
    document.getElementById("react-publish-container")
  );
}



// WEBPACK FOOTER //
// ./enso_cms/static/enso-cms/js/publish.js